import { render } from "./NewChatModal.vue?vue&type=template&id=2cb43e90&scoped=true"
import script from "./NewChatModal.vue?vue&type=script&lang=js"
export * from "./NewChatModal.vue?vue&type=script&lang=js"

import "./NewChatModal.vue?vue&type=style&index=0&id=2cb43e90&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb43e90"]])

export default __exports__